if($('.type-detail').length){
   
    $(".detail-parameters tr").each(function() {
        var $this = $(this)
        if($this.find('th').text().trim() === 'Page type:'){
            if($this.closest('tr').find('td').text().trim()==='balení'){
                $('.p-data-wrapper .p-final-price-wrapper .price-measure').hide();
            }
        }
    })
    if($('.surcharge-list').length){
        // Získání domény e-shopu
        var domain = window.location.hostname; 
        // Sestavení klíče pro localStorage
        var storageKey = 'surachrgedata-' + domain;

        // Funkce pro zpracování dat
        function surchargeCreateSelect(surchargeData) {
        if ($(".surcharge-list").length) {
            $(".p-to-cart-block").before('<div class="surcharge-wrap"></div>');

            $(".surcharge-list select.surcharge-parameter").each(function() {
                var $this = $(this);
                var find_surcharge_label = "";

                if ($this.closest(".surcharge-list").find(".surcharge-label>span").length) {
                    find_surcharge_label = $this.closest(".surcharge-list").find(".surcharge-label>span").attr("title") || "";
                }

                var data_surcharge_id = $this.data("parameter-id");
                var data_surcharge_text = $this.data("parameter-name").trim().split("#")[0];

                // Najdeme objekt z surchargeData podle ID
                var itemData = surchargeData.find(function(item) {
                    return item.id == data_surcharge_id;
                });

                var itemType = itemData ? itemData.typ : null;
                var itemTitle = itemData ? itemData.nadpis : '';
                var itemDesc = itemData ? itemData.popis : '';

                // Podle typu vykreslíme příslušný HTML obsah
                if (itemType === "#checkboxnote") {
                    var click_box = '<div class="select-surcharge" data-id="' + data_surcharge_id + '">';
                    click_box += '<div class="var_inner" data-id="' + data_surcharge_id + '">';

                    $this.find("option").each(function() {
                    var find_option_text = $(this).text(),
                        surcharge_val = find_option_text.split("+")[0].trim(),
                        find_surcharge_value = $(this).val();

                    if ($.isNumeric(find_surcharge_value)) {
                        click_box += '<div class="surcharge-box-message" data-full-name="' + (itemTitle ? itemTitle : '') + ' - ' + $(this).text() + '" data-val="' + find_surcharge_value + '" data-parameter-id="' + data_surcharge_id + '" data-value="' + surcharge_val + '">';
                        click_box += '<div class="surcharge-title">' + data_surcharge_text + ". " + find_surcharge_label + "</div>";
                        click_box += "</div>";
                    }
                    });

                    click_box += "</div></div>";
                    $(".surcharge-wrap").append(click_box);

                    // Pokud je potřeba popup
                    $(".surcharge-wrap").before('<div class="narez-popup"><h3>Úprava rozměru na míru</h3><span class="close"></span><p>' + (itemDesc ? itemDesc : '') + '</p><textarea placeholder="Zadejte rozměr"></textarea><div class="left"><span class="potvrdit">Potvrzuji rozměr</span></div></div>');
                    $this.closest(".surcharge-list").hide();
                } else if (itemType === "#checkbox") {
                    var priplatek = '<div class="select-surcharge" data-id="' + data_surcharge_id + '" data-type="'+itemType+'">';
                    priplatek += '<div class="var_inner" data-id="' + data_surcharge_id + '">';
                    $this.find("option").each(function() {
                        var find_option_text = $(this).text(),
                            surcharge_val = find_option_text.split("+")[0].trim(),
                            find_surcharge_value = $(this).val();
                        if ($.isNumeric(find_surcharge_value)) {
                            priplatek += '<div class="surcharge-box" data-val="' + find_surcharge_value + '" data-parameter-id="' + data_surcharge_id + '" data-value="' + surcharge_val + '">';
                            priplatek += '<div class="surcharge-title">' + data_surcharge_text + ". " + find_surcharge_label + "</div>";
                            priplatek += "</div>";
                        }
                    });

                    priplatek += "</div></div>";
                    $(".surcharge-wrap").append(priplatek);
                    $this.closest(".surcharge-list").hide();

                } else if (itemType === "#info") {
                    $(".surcharge-wrap").append('<div class="infoBox">'+itemTitle+' '+itemDesc+'</div>');
                    $this.closest(".surcharge-list").hide();

                } else {
                    // Fallback logika
                /* var text_icka = '<div class="info-text">' + find_surcharge_label + "</div>";
                    $this.closest(".surcharge-list").find(".surcharge-label").after(text_icka);
                    $this.closest(".surcharge-list").find(".surcharge-label>span").replaceWith('<span class="open-text">?</span>');*/
                }

            // Skryje původní seznam
            //$this.closest(".surcharge-list").hide();
            });
        }
        }
        var storedData = localStorage.getItem(storageKey);
        if (storedData) {
        var parsedData = JSON.parse(storedData);
        surchargeCreateSelect(parsedData);
        } else {
            $.ajax({
                url: '/user/documents/jsonSurcharge.json?v='+new Date().getMinutes(),
                dataType: 'json',
                success: function(surchargeData) {
                    localStorage.setItem(storageKey, JSON.stringify(surchargeData));
                    surchargeCreateSelect(surchargeData);
                },
                error: function() {
                    console.error("Nepodařilo se načíst JSON s příplatky.");
                }
            });
        }
    }
}